// extracted by mini-css-extract-plugin
export default {"homepage":"Home_homepage__NRb3m","posts":"Home_posts__ZX5ha","see-more":"Home_see-more__5Uw1t","moveLine":"Home_moveLine__78Lvu"};